import { Pipe, PipeTransform } from '@angular/core';
import { DecimalPipe } from '@angular/common';

@Pipe({
    name: 'numberFormat',
    standalone: false
})
export class NumberFormatPipe implements PipeTransform {
  constructor(private decimalPipe: DecimalPipe) {}

  public transform(value: any): any {
    if (value === undefined || value === null) {
      return value;
    }
    return this.decimalPipe.transform(value || 0, '1.2-2', 'da');
  }
}
